var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MediaStorageCropperProvider',{scopedSlots:_vm._u([{key:"default",fn:function({ cropperProps }){return [_c('img',{staticClass:"preview-image cropperPreviewImage",style:({ ...cropperProps(_vm.tag).previewStyles }),attrs:{"src":_vm.image,"alt":"previewImageSrc"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }